import { FieldPolicy, TypePolicy } from '@apollo/client/react'
import { uniqBy } from 'lodash'

export function scoCollectionItemsPagination(): FieldPolicy {
  return {
    keyArgs: false,
    merge: (existing, incoming) => {
      const newItems = [...(existing || []), ...(incoming || [])]
      const uniqueNewItems = uniqBy(newItems, x => x.__ref)
      return uniqueNewItems
    },
  }
}

export function scoCollectionPagination(): TypePolicy {
  return {
    keyFields: ['id'],
    fields: {
      items: scoCollectionItemsPagination(),
    },
  }
}
